import { render } from "./ChapterForm.vue?vue&type=template&id=6176a68c&scoped=true"
import script from "./ChapterForm.vue?vue&type=script&lang=js"
export * from "./ChapterForm.vue?vue&type=script&lang=js"

import "./ChapterForm.vue?vue&type=style&index=0&id=6176a68c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6176a68c"]])

export default __exports__